import React, { useEffect, useMemo, useState } from 'react';
import { Button, Card, Col, DatePicker, Descriptions, Empty, Form, Input, InputNumber, Modal, Pagination, Row, Select, Table, Tabs, Typography } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { BaleService } from '@gtpl/shared-services/raw-material-procurement';
import moment from 'moment';
import { ColumnProps } from 'antd/lib/table';
import { TabNameReq } from '@gtpl/shared-models/raw-material-procurement';
import { ProductService } from '@gtpl/shared-services/masters';
import  ExcelJs from 'exceljs'
import './bale-info-report.css'
const BaleInfoReport = () => {
  const [data, setData] = useState<any[]>([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const baleService = new BaleService();
  const [filterForm] = Form.useForm()
  const [inwardNumber, setInwardNumber] = useState<any[]>([])
  const [voucherNumber, setVoucherNumber] = useState<any[]>([])
  const [agent, setAgent] = useState<any[]>([])
  const [baleNumber, setBaleNumber] = useState<any[]>([])
  const [variants, setVariants] = useState<any[]>([])
  const variantService = new ProductService()
  const [form] = Form.useForm()
  const { Option } = Select
  const formatNumber = (value: any) =>
  value != null ? Number(Number(value).toFixed(2)) : '-';
  const handleExportExcel = async () => {
    if (!data || data.length === 0) {
      return;
    }

    const workbook = new ExcelJs.Workbook();
    const worksheet = workbook.addWorksheet('Bale Info Report');

    const headerRow = [
      'S No',
      'Bale No',
      'Bale Type',
      'Bale Date',
      'Bale Variant',
      'Gross Qty',
      'Bale Quality',
      'Bale Status',
      'Tare Wt',
      'Actual Bale Qty',
      'Old Qty Log 1',
      'Old Qty Log 2',
      'Inward No',
      'Voucher No',
      'Inward Qty',
      'Inward Variant',
      'Inward Quality',
    ];

    worksheet.addRow(headerRow);

    let excelRowIndex = 2;
    // Export ALL fetched bales (not only current page),
    // but keep bale-wise merged columns + bale-based serial numbering.
    let serialNo = 1;
    const exportBales = data;

    exportBales.forEach((bale: any) => {
      const items = bale.itemsInfo && bale.itemsInfo.length > 0 ? bale.itemsInfo : [{}];
      const baleRowSpan = items.length;

      const log1 = bale.baleQtyLogs?.[0];
      const log2 = bale.baleQtyLogs?.[1];

      items.forEach((item: any, itemIndex: number) => {
        const isFirstItem = itemIndex === 0;

        const rowValues = [
          isFirstItem ? (serialNo || '-') : '',
          isFirstItem ? (bale.baleNumber || '-') : '',
          isFirstItem ? (bale.type || '-') : '',
          isFirstItem
            ? (bale.baleDate ? new Date(bale.baleDate).toLocaleDateString('en-GB') : '-')
            : '',
          isFirstItem ? (bale.baleVariant || '-') : '',
          isFirstItem ? formatNumber(bale.grossWeight) : '',
          isFirstItem ? bale.baleQuality : '',
          isFirstItem ? (bale.status || '-') : '',
          isFirstItem ? formatNumber(bale.tareWeight) : '',
          isFirstItem ? formatNumber(bale.actualBaleQty) : '',
          isFirstItem ? formatBaleQtyLog(log1) : '',
          isFirstItem ? formatBaleQtyLog(log2) : '',
          item.inwardNumber || '-',
          item.voucherNumber || '-',
          item.baleQty ? formatNumber(item.baleQty) : '-',
          item.variant || '-',
          item.quality || '-',
        ];

        worksheet.addRow(rowValues);
        excelRowIndex += 1;
      });

      if (baleRowSpan > 1) {
        const startRow = excelRowIndex - baleRowSpan;
        const endRow = excelRowIndex - 1;

        // Merge bale-level columns (including S No) vertically for each bale
        for (let col = 1; col <= 12; col += 1) {
          worksheet.mergeCells(startRow, col, endRow, col);
        }
      }

      serialNo += 1;
    });

    headerRow.forEach((_, index) => {
      const column = worksheet.getColumn(index + 1);
      column.width = 15;
    });

    worksheet.getRow(1).font = { bold: true };

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'Bale_Info_Report.xlsx';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  };

  const getBaleReportInfo = () => {
const req: any = {};
      if (filterForm.getFieldValue('variant')) {
        req.variant = filterForm.getFieldValue('variant')
      }
      if (filterForm.getFieldValue('voucherNumber')) {
        req.voucherNumber = filterForm.getFieldValue('voucherNumber')
      }
      if (filterForm.getFieldValue('inwardNumber')) {
        req.inwardNumber = filterForm.getFieldValue('inwardNumber')
      }
      if (filterForm.getFieldValue('baleNumber')) {
        req.baleNumber = filterForm.getFieldValue('baleNumber')
      }
      if (filterForm.getFieldValue('baleDate') && filterForm.getFieldValue('baleDate')[0]) {
        req.fromDate = (filterForm.getFieldValue('baleDate')[0]).format('YYYY-MM-DD');
        req.toDate = (filterForm.getFieldValue('baleDate')[1]).format('YYYY-MM-DD');
      }
          baleService.getBaleReportInfo(req).then((res: any) => {
      if (res?.status) {
        setData(res.data || []);
      } else {
        setData([]);
      }
    });
  };

  useEffect(() => {
    getBaleReportInfo();
    getInwardNumberInfo()
    getVoucherNumberInfo()
    getVariants()
    getBaleNumberInfo()
  }, []);

  useEffect(() => {
    // Prevent empty table when filters change and current page becomes out of range.
    const maxPage = Math.max(1, Math.ceil((data?.length || 0) / pageSize));
    if (page > maxPage) setPage(1);
  }, [data?.length, pageSize]);

  const formatLogDate = (value?: string) => {
    if (!value) return '-';
    const normalized = value.includes(' ') ? value.replace(' ', 'T') : value;
    const date = new Date(normalized);
    return Number.isNaN(date.getTime()) ? value : date.toLocaleString('en-GB');
  };


  const getInwardNumberInfo = () => {
    baleService.getInwardNumberDropDownInfo().then(res => {
      if (res.status) {
        setInwardNumber(res.data)
      } else {
        setInwardNumber([])
      }
    })
  }
  const getVariants = () => {

    variantService.getAllActiveProducts().then(res => {
      if (res.status) {
        setVariants(res.data)
      } else {
        setVariants([])
      }
    })
  }
  const getVoucherNumberInfo = () => {

    baleService.getVoucherNumberDropDownInfo().then(res => {
      if (res.status) {
        setVoucherNumber(res.data)
      } else {
        setVoucherNumber([])
      }
    })
  }


  const getBaleNumberInfo = () => {
    baleService.getBaleNumberDropDownInfo().then(res => {
      if (res.status) {
        setBaleNumber(res.data)
      } else {
        setBaleNumber([])
      }
    })
  }

   const onReset = () => {
    filterForm.resetFields()
    getBaleReportInfo()
  }

  const formatBaleQtyLog = (log?: { createdDate?: string; oldQuantity?: number | string }) => {
    if (!log) return '-';
    const qty = log.oldQuantity ?? '-';
    const dateText = moment(log.createdDate).format('DD-MMM');
    return `${qty} (${dateText})`;
  };

  // "pageSize" means 10 bale numbers per page.
  const currentBales = useMemo<any[]>(() => {
    const start = (page - 1) * pageSize;
    return data.slice(start, start + pageSize);
  }, [data, page, pageSize]);

  const tableData = useMemo<any[]>(() => {
    const rows: any[] = [];

    currentBales.forEach((bale, baleIndex) => {
      const items = bale.itemsInfo && bale.itemsInfo.length > 0 ? bale.itemsInfo : [{}];
      const baleRowSpan = items.length;

      const log1 = bale.baleQtyLogs?.[0];
      const log2 = bale.baleQtyLogs?.[1];

      const baleSerialNo = (page - 1) * pageSize + baleIndex + 1;

      items.forEach((item, itemIndex) => {
        rows.push({
          key: `${bale.baleNumber || 'bale'}-${baleIndex}-${itemIndex}`,
          rowSpan: itemIndex === 0 ? baleRowSpan : 0,
          sno: itemIndex === 0 ? baleSerialNo : '',
          baleNumber: bale.baleNumber || '-',
          type: bale.type || '-',
          baleDate: bale.baleDate ? new Date(bale.baleDate).toLocaleDateString('en-GB') : '-',
          baleVariant: bale.baleVariant || '-',
          grossWeight: bale.grossWeight || '-',
          baleQuality: bale.baleQuality || '-',
          baleStatus: bale.status || '-',
          tareWeight: bale.tareWeight || '-',
          actualBaleQty: bale.actualBaleQty || '-',
          baleQtyLog1: formatBaleQtyLog(log1),
          baleQtyLog2: formatBaleQtyLog(log2),
          inwardNumber: item.inwardNumber || '-',
          voucherNumber: item.voucherNumber || '-',
          inwardQty: item.baleQty || '-',
          inwardVariant: item.variant || '-',
          inwardQuality: item.quality || '-',
        });
      });
    });

    return rows;
  }, [currentBales, page, pageSize]);

  const mergedColumn = (dataIndex: string) => ({
    render: (value: any, record: any) => ({
      children: value,
      props: { rowSpan: record.rowSpan },
    }),
    dataIndex,
  });

  const columns: ColumnProps<any>[] = [
    {
      title: 'S No',
      key: 'sno',
      width: 72,
      align: 'center',
      fixed: 'left',
      ...mergedColumn('sno'),
    },
    { title: 'Bale No', key: 'baleNumber', ...mergedColumn('baleNumber') },
    { title: 'Bale Type', key: 'type', ...mergedColumn('type') },
    { title: 'Bale Date', key: 'baleDate', ...mergedColumn('baleDate') },
    { title: 'Bale Variant', key: 'baleVariant', ...mergedColumn('baleVariant') },
    { title: 'Gross Qty', key: 'grossWeight', ...mergedColumn('grossWeight') ,render: (value) => Number(Number(value).toFixed(2))},
    { title: 'Bale Quality', key: 'baleQuality', ...mergedColumn('baleQuality'), },
    { title: 'Bale Status', key: 'baleStatus', ...mergedColumn('baleStatus') },
    { title: 'Tare Wt', key: 'tareWeight', ...mergedColumn('tareWeight') ,render: (value) => Number(Number(value).toFixed(2))},
    { title: 'Actual Bale Qty', key: 'actualBaleQty', ...mergedColumn('actualBaleQty'),render: (value) => Number(Number(value).toFixed(2)) },
    { title: 'Old Qty Log 1', key: 'baleQtyLog1', ...mergedColumn('baleQtyLog1') },
    { title: 'Old Qty Log 2', key: 'baleQtyLog2', ...mergedColumn('baleQtyLog2') },
    { title: 'Inward No', dataIndex: 'inwardNumber', key: 'inwardNumber' },
    { title: 'Voucher No', dataIndex: 'voucherNumber', key: 'voucherNumber' },
    { title: 'Inward Qty', dataIndex: 'inwardQty', key: 'inwardQty' ,render: (value) => Number(Number(value).toFixed(2))},
    { title: 'Inward Variant', dataIndex: 'inwardVariant', key: 'inwardVariant' },
    { title: 'Inward Quality', dataIndex: 'inwardQuality', key: 'inwardQuality' },
  ];

  return (

    <Card title={<span style={{ color: 'white' }}>Bale Info Report</span>} style={{ textAlign: 'center' }} headStyle={{ backgroundColor: '#69c0ff', border: 0 }}
      extra={
        <>
          <Button
            type="primary"
            style={{ marginRight: '10px' }}
            onClick={handleExportExcel}
          >
            Get Excel
          </Button>
        </>
      }
    >
      <Form form={filterForm} layout='vertical'>
        <Row gutter={[16, 16]}>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }}>
            <Form.Item label='Bale Number' name='baleNumber'>
              <Select allowClear showSearch optionFilterProp='children' placeholder='Select Bale Number' mode='multiple'>
                {
                  baleNumber.map(e => {
                    return (
                      <Option key={e.baleNumber} value={e.baleNumber}>{e.baleNumber}</Option>
                    )
                  })
                }
              </Select>
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }}>
            <Form.Item
              name="baleDate"
              label="Bale Date"
            >
              <DatePicker.RangePicker />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 4 }}>
                  <Form.Item label={'Bale Variant'} name='variant' >
                    <Select allowClear showSearch optionFilterProp='children' placeholder='Select Variant'>
                      {
                        variants.map(e => {
                          return (
                            <Option key={e.productId} value={e.productId}>{e.productName}</Option>
                          )
                        })
                      }
                    </Select>
                  </Form.Item>
                </Col>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 4 }}>
            <Form.Item label='Inward Number' name='inwardNumber'>
              <Select allowClear showSearch optionFilterProp='children' placeholder='Select Inward Number' mode='multiple'>
                {
                  inwardNumber.map(e => {
                    return (
                      <Option key={e.inwardNumber} value={e.inwardNumber}>{e.inwardNumber}</Option>
                    )
                  })
                }
              </Select>
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 4 }}>
            <Form.Item label='Voucher Number' name='voucherNumber'>
              <Select allowClear showSearch optionFilterProp='children' placeholder='Select Voucher Number' mode='multiple'>
                {
                  voucherNumber.map(e => {
                    return (
                      <Option key={e.voucherNumber} value={e.voucherNumber}>{e.voucherNumber}</Option>
                    )
                  })
                }
              </Select>
            </Form.Item>
          </Col>
          
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 2 }}>
              <Form.Item>
                <Button type='primary' onClick={getBaleReportInfo}>Search</Button>
              </Form.Item>
            </Col>
            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 2 }}>
              <Form.Item>
                <Button danger onClick={onReset}>Reset</Button>
              </Form.Item>
            </Col>
        </Row>
      </Form>
      <Table
        bordered
        columns={columns}
        dataSource={tableData}
        rowKey={(r) => r.key}
        pagination={false}
        rowClassName={() => 'custom-white-row'}
        locale={{ emptyText: <Empty description="No bale information found" /> }}
        scroll={{ x: 'max-content' }}
      />

      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
        <Pagination
          current={page}
          pageSize={pageSize}
          total={data.length}
          showSizeChanger
          pageSizeOptions={['10', '20', '50', '100']}
          showTotal={(total) => `${total} bale(s)`}
          onChange={(current, size) => {
            setPage(current);
            if (size && size !== pageSize) setPageSize(size);
          }}
          onShowSizeChange={(_current, size) => {
            setPage(1);
            setPageSize(size);
          }}
        />
      </div>
    </Card>
  );
};

export default BaleInfoReport;